module.exports = __webpack_public_path__ + "img/user.aa0ba04d.png";